<template>
  <div>
    <VanTrucking
      ref="van"
      v-if="request_quotation.service_type == 6"
      :request_quotation.sync="request_quotation"
    />
    <ContainerTrucking
      ref="containerTrucking"
      @cut-off="setCutOff"
      v-if="request_quotation.service_type == 5"
      :request_quotation.sync="request_quotation"
    />
    <AIR
      ref="AIR"
      @cut-off="setCutOff"
      v-if="request_quotation.service_type == 1"
      :request_quotation.sync="request_quotation"
    />
    <LCL
      ref="LCL"
      @cut-off="setCutOff"
      v-if="request_quotation.service_type == 3"
      :request_quotation.sync="request_quotation"
    />
    <FCL
      ref="FCL"
      @cut-off="setCutOff"
      v-if="request_quotation.service_type == 2"
      :request_quotation="request_quotation"
    />

    <Customs
      ref="Customs"
      @cut-off="setCutOff"
      v-if="request_quotation.service_type == 4"
      :request_quotation="request_quotation"
    />
    <b-col cols="12" class="p-2">
      <a
        @click="handleSubmit"
        class="btn btn-warning round pl-2 pr-2 mr-1 mr-auto"
        ><feather-icon icon="SendIcon" />
        Submit
      </a>
    </b-col>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Select2 from "v-select2-component";
import useJwt from "@/auth/jwt/useJwt";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { $ctx } from "@themeConfig";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import LCL from "./from-booking/LCL.vue";
import AIR from "./from-booking/AIR.vue";

import { mapState, mapActions } from "vuex";

export default {
  props: {
    step: { default: "booking" },
    request_quotation: { default: null },
    readonly: { default: false },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    Select2,
    vueDropzone: vue2Dropzone,
    VanTrucking: () => import("./from-booking/VanTrucking.vue"),
    ContainerTrucking: () => import("./from-booking/ContainerTrucking.vue"),
    LCL,
    AIR,
    FCL: () => import("./from-booking/FCL.vue"),
    Customs: () => import("./from-booking/Customs.vue"),
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      showTimePanel: false,
      showTimeRangePanel: false,
      isHideShow: false,
      isHideShowPk: false,
      maxFiles: false,
      isHideShowBookingEdit: false,
      isHideShowPkBookingEdit: false,
      quotationInfo: null,
      totalFiles: 0,
      dropzoneOptions: {
        url: $ctx.API_URL + this.$Utils.CONSTANTS.TYPE_UPLOAD.URL,
        addRemoveLinks: !this.readonly,
        acceptedFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.type,
        maxFilesize: this.$Utils.CONSTANTS.TYPE_UPLOAD.size,
        maxFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.max,
        headers: { apiKey: localStorage.getItem("accessToken") },
        clickable: !this.readonly,
      },
    };
  },
  computed: {
    ...mapState("masterData", [
      "locations",
      "sales",
      "cont_types",
      "goods_types",
      "regions",
    ]),
  },
  created() {
    // useJwt
    //   .get("masterData?data=All", {})
    //   .then((response) => {
    //     this.locations = response.data.result.Location;
    //     this.cont_types = response.data.result.ContType;
    //     this.goods_types = response.data.result.GoodsType;
    //     this.regions = response.data.result.Region;
    //   })
    //   .finally(() => {
    //     this.$loading.hide();
    //   });
  },
  mounted() {
    this.isHideShow =
      this.request_quotation.other_pickup_location != null ? true : false;

    this.isHideShowPk =
      this.request_quotation.other_delivery_location != null ? true : false;

    this.isHideShow =
      this.request_quotation.other_pickup_region != null ? true : false;

    this.isHideShowPk =
      this.request_quotation.other_delivery_region != null ? true : false;
  },
  methods: {
    setCutOff(n) {
      this.request_quotation.cut_off = n;
    },
    disabledRangeDelivery: function (date) {
      if (this.request_quotation.pick_up_date) {
        var mydate = moment(this.request_quotation.pick_up_date, "DD/MM/YYYY");

        //format that date into a different format
        var now = moment(mydate).format("MM/DD/YYYY");

        return date < new Date(now);
      }
    },
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleCloseChange() {
      this.$refs.datePicker.popupVisible = false;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
    hideShows: function () {
      this.isHideShow = !this.isHideShow;
    },
    hideShowsPk: function () {
      this.isHideShowPk = !this.isHideShowPk;
    },
    changeHideShows: function () {
      this.isHideShowBookingEdit = !this.isHideShowBookingEdit;
    },
    changeHideShowsPk: function () {
      this.isHideShowPkBookingEdit = !this.isHideShowPkBookingEdit;
    },

    handleSubmit() {
      switch (this.request_quotation.service_type) {
        case "1":
          this.$refs.AIR.onSubmit();
          return;
        case "2":
          this.$refs.FCL.onSubmit();
          return;
        case "3":
          this.$refs.LCL.onSubmit();
          // this.$refs.LCL.onSubmit();
          return;
        case "4":
          this.$refs.Customs.onSubmit();
          return;
        case "5":
          this.$refs.containerTrucking.onSubmit();
          return;
        case "6":
          this.$refs.van.onSubmit();
          return;
        default:
          return;
      }
    },
  },
};
</script>

<style lang="scss">
.vue-dropzone > .dz-preview .dz-details {
  background-color: #2b938c;
  border-radius: 15px;
}
</style>